module.exports = __webpack_public_path__ + "img/sell-light.ef8bc98.svg";